import httpClient from '@utils/httpClient.js';

const getProfileId = () => localStorage.getItem('unilinkProfileId');

export function updateLinksBlockApiCall(options) {
  const { id, headingTitle, headingDescription, layout } = options;

  return httpClient.put(`api/profiles/${getProfileId()}/email-marketing/block/links`, {
    id,
    headingTitle,
    headingDescription,
    layout,
  });
}

export function addLinksItemApiCall(options) {
  const { id, title, description, image, url } = options;

  return httpClient.post(`api/profiles/${getProfileId()}/email-marketing/block/link`, {
    id,
    title,
    description,
    image,
    url,
  });
}

export function updateLinksItemApiCall(id, options) {
  return httpClient.put(`api/profiles/${getProfileId()}/email-marketing/block/link/${id}`, options);
}

export function deleteLinksItemApiCall(id) {
  return httpClient.delete(`api/profiles/${getProfileId()}/email-marketing/block/link/${id}`);
}
